<!-- data table -->
<div 
*ngIf="!isMobile"
matSort 
class="table-div"
(matSortChange)="sortData($event)">
    <table class="table table-striped">
        <thead>
            <tr>
                <th 
                scope="col"
                mat-sort-header="username">
                    Username
                </th>
                
                <th 
                scope="col"
                mat-sort-header="email">
                    E-mail
                </th>

                <th 
                scope="col"
                mat-sort-header="firstname">
                    Firstname
                </th>

                <th 
                scope="col"
                mat-sort-header="lastname">
                    Lastname
                </th>
                
                <th 
                scope="col">
                    Role
                </th>
                
            </tr>
        </thead>
        <tbody *ngIf="!isLoading && !message">
            <tr class="user-tr" (click)="onItemClick(user)" *ngFor="let user of userList; index as i">
                <td>{{ user.username }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.firstname }}</td>
                <td>{{ user.lastname }}</td>
                <td>{{ globalservice.userLevelTransition(user.userLevel) }}</td>

                <td>
                    <button 
                    (click)="openDetails(user, $event)"
                    class="download-btn">
                        View Details
                    </button>
                </td>
            </tr>
        </tbody>

        <div 
        *ngIf="message && !isLoading" 
        class="m-auto error-message">
            <span>{{message}}</span>
        </div>
        
        <div *ngIf="isLoading" class="table-spinner-div">
            <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
        </div>
        
    </table>

    <app-user-details/>

</div>
